import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';

const searchSchema = z.object({
  status: z.enum(['success', 'error']).optional(),
});

export const Route = createFileRoute('/unos_/oauth_/callback')({
  validateSearch: searchSchema,
  component: UnosOauthCallback,
});

function UnosOauthCallback() {
  const { status } = Route.useSearch();
  const navigate = useNavigate();

  // biome-ignore lint/correctness/useExhaustiveDependencies: on mount only
  useEffect(() => {
    if (window.opener) {
      window.opener.postMessage({ type: 'unos-oauth-complete', status: status ?? 'error' }, window.location.origin);
      window.close();
    } else {
      navigate({ to: '/' });
    }
  }, []);

  return null;
}
